import React from "react";
import { Button, ButtonSize, ButtonVariant } from "@wattpad/web-ui-library";

import { useTrans } from "../../hooks";

const WriterReivewBanner = () => {
  const { trans } = useTrans();

  return (
    <div className="writer-review-container">
      <span className="typography-paragraph-medium">
        {/* I am not translating this string yet because the date has not been set but it's not a var */}
        {
          "Add a story type to help readers find your story. On [date], we'll assign a story type to stories still missing one."
        }
      </span>
      <div className="review-buttons">
        <Button
          variant={ButtonVariant.PRIMARY}
          label={trans("Review Stories")}
          size={ButtonSize.SMALL}
          ariaLabel={trans("Review Stories")}
          href={`/write/stories/review`}
        />
        <Button
          variant={ButtonVariant.SECONDARY}
          size={ButtonSize.SMALL}
          label={trans("Learn more")}
          ariaLabel={trans("Learn more")}
          href={`https://docs.google.com/document/d/1Nv-YEQzH0pwwIs-U5wuHx3kFft_UWJJFV2U36fLZ09c/edit?tab=t.0`}
        />
      </div>
    </div>
  );
};

export default WriterReivewBanner;
